import { render, staticRenderFns, recyclableRender, components } from "./appointmentDetails.vue?vue&type=template&id=6f8ffd34&scoped=true&"
var renderjs
import script from "./appointmentDetails.vue?vue&type=script&lang=js&"
export * from "./appointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./appointmentDetails.vue?vue&type=style&index=1&id=6f8ffd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ffd34",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/appointmentDetails/appointmentDetails.vue"
export default component.exports